import { createSlice } from "@reduxjs/toolkit";
import { sendOTPThunk, verifyOTPThunk } from "./phoneThunks";

interface PhoneState {
  loading: boolean;
  error: string | null;
}

const initialState: PhoneState = {
  loading: false,
  error: null,
};

const phoneSlice = createSlice({
  name: "phone",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendOTPThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendOTPThunk.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(sendOTPThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(verifyOTPThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyOTPThunk.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(verifyOTPThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default phoneSlice.reducer;
